import { useMemo } from 'react'
import { useParams } from 'wouter'
import { useSuspenseQuery } from '@apollo/client/react'
import { AdminAPI, getFragment, SharedAPI } from '@guestgoodie/graphql'
import { useLingui } from '@lingui/react/macro'

import { Suspense } from '@/components/ui/Suspense'
import { DialogHeader } from '@/layouts/Dialog'
import { StayOrders } from '@/features/order'

function StayOrdersContainer({ token }: { token: string }) {
  const { t } = useLingui()

  const { data } = useSuspenseQuery(AdminAPI.stay.GET_BY_TOKEN, {
    variables: { token },
    fetchPolicy: 'cache-and-network'
  })

  const stay = useMemo(
    () => getFragment(SharedAPI.stay.STAY_FRAGMENT, data.getStayByToken),
    [data]
  )

  return (
    <div className="flex flex-col gap-7 p-5">
      <DialogHeader
        title={t`Orders`}
        description={t({
          comment:
            'Description of a dialog showing all orders for a guest stay.',
          message: `All orders (including pending and canceled) for the guest stay.`
        })}
      />
      <StayOrders stayId={stay.id} />
    </div>
  )
}

export default function StayOrdersSuspense() {
  const params = useParams() as { token: string }

  if (!params) return null

  return (
    <Suspense isDialog>
      <StayOrdersContainer token={params.token} />
    </Suspense>
  )
}
